<template>

  <div class="pb50">
    <el-form ref="form" size="small" :model="form">
       <el-form-item label="是否开启活动申请通道">
        <el-radio-group v-model="form.is_activity_open">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="举办积分 " prop="points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.points" class="max-w460">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="活动申请限制人数 " prop="max_num" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入数值" type="number" min="0" v-model="form.max_num" class="max-w460">
          <template slot="append">人</template>
        </el-input>
        <div class="gray">为零不限制</div>
      </el-form-item>
      <el-form-item label="分享获得 " prop="share_points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.share_points" class="max-w460">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="每天最多可得 " prop="share_day_limit" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入数值" type="number" min="0" v-model="form.share_day_limit" class="max-w460">
          <template slot="append">次转发积分</template>
        </el-input>
      </el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>

    </el-form>
  </div>
</template>
<script>
  import ActivityApi from '@/api/activity.js';
  export default {
    data() {
      return {
        form: {
          points: 0,
          max_num: 0,
          share_day_limit: 0,
          share_points: 0,
          is_activity_open: 0,
        },
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        ActivityApi.getSetting(Params, true).then(res => {
          self.form = res.data.setting;
         if(res.data.setting.is_activity_open){
             self.form.is_activity_open = parseInt(res.data.setting.is_activity_open);
          }
        }).catch(error => {

        });
      },

      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            ActivityApi.setSetting(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });

          }
        });


      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/setting/Setting.vue